import { getField, updateField } from 'vuex-map-fields';
import { formatMoney, unformat } from 'accounting-js';
import { round } from 'lodash';
export const agreement = {
	namespaced: true,
	state: {
		agreed_to_copies: null,
		authorized_agent: {
			signature: null,
			signature_points: [],
			date: null
		},
		witness: {
			signature: null,
			signature_points: [],
			name: null,
			title: null,
			date: null
		}
	},
	getters: {
		getField
	},
	mutations: {
		updateField,
		setAuthorizedAgent(state, {signature}){
			state.authorized_agent.signature = signature;
			state.authorized_agent.date = new Date();
		},
		setWitness(state, {signature}){
			state.witness.signature = signature;
			state.witness.date = new Date();
		}
	}
}

export const attachments = {
	namespaced: true,
	state: {
		area_maps: [],
		plats: [],
		photos: [],
		appraisals: [],
		landowner_letters: [],
		adjacent_landowner_letters: [],
		support_letters: [],
		municipal_endorsements: [],
		board_member_list: [],
		articles_of_incorporation: [],
		//secretary_of_state_notification: [],
		master_plans: [],
		landowner_disclosures: [],
		other: []
	},
	getters: {
		getField,
		getFileList: (state) => (category) => {
			return state[category];
		}
	},
	mutations: {
		updateField,
		addFileToStore(state, { category, file }){
			state[category].push(file);
		},
		removeFileFromStore(state, { category, file }){
			const file_index = state[category].map(item => item.name).indexOf(file.name);
			state[category].splice(file_index, 1);
		}
	},
	actions: {
		addFileToStore({ state, commit, dispatch }, payload){
			commit('addFileToStore', payload);
			dispatch('application/patchApplication', { path: ['attachments', payload.category] , value: state[payload.category]}, { root: true });
		},
		removeFileFromStore({ state, commit, dispatch }, payload){
			commit('removeFileFromStore', payload);
			dispatch('application/patchApplication', { path: ['attachments', payload.category] , value: state[payload.category]}, { root: true });
		}
	}
}

export const applicant_information = {
	namespaced: true,
	state: {
		organization_name: null,
		is_non_profit: null,
		mailing_address: {
			street_1: null,
			street_2: null,
			city: null,
			state: null,
			zip: null
		},
		authorized_agent: {
			name: null,
			title: null,
			phone: null,
			email: null
		},
		contact_person: {
			name: null,
			title: null,
			phone: null,
			email: null
		},
		ensuring_completion: null,
		total_acres: null,
		land_already_preserved: null,
		financial_participants: null
	},
	getters: {
		getField
	},
	mutations: {
		updateField
	}
}

export const project_information = {
	namespaced: true,
	state: {
		rural_or_urban: null,
		project_park_name: null,
		brief_description: null
	},
	getters: {
		getField
	},
	mutations: {
		updateField
	}
}

export const property_information = {
	namespaced: true,
	state: {
		landowner: {
			name: null,
			is_entity: null,
			business_partners: null,
			mailing_address: {
				street_1: null,
				street_2: null,
				city: null,
				state: null,
				zip: null
			}
		},
		property_address: {
			street_1: null,
			street_2: null,
			city: null,
			state: null,
			zip: null
		},
		jurisdiction: {
			is_unincorporated_charleston_county: null,
			municipality: null,
			number_of_parcels: null
		},
		acreage_distribution: {
			forested: null,
			cleared: null,
			wetlands: null
		},
		tax_map_numbers: null,
		zoning_status: null,
		assessor_plot_lot_numbers: null,
		deed_book_page_number: null,
		land_use_description: null,
		site_accessibility: {
			is_road_accessible: null,
			road_types: [],
			unimproved_roads: null,
			improved_roads: null
		},
		water_access: {
			has_water_access: null,
			types_of_access: [],
			freshwater_stream_creek_names: null,
			tidal_creek_names: null,
			deep_river_names: null
		}
	},
	getters: {
		getField,
		totalAcreage: state => round((state.acreage_distribution.forested || 0 ) + (state.acreage_distribution.cleared || 0 ) + (state.acreage_distribution.wetlands || 0 ), 2)
	},
	mutations: {
		updateField
	}
}

export const acquisition_information = {
	namespaced: true,
	state: {
		type: [],
		payment_method: null,
		other_description: null
	},
	getters: {
		getField
	},
	mutations: {
		updateField
	}
}

export const fair_market_value = {
	namespaced: true,
	state: {
		is_including_appraisal: null,
		appraised_value: null,
		estimated_value: null,
		value_estimation_description: null,
		land_has_structures: null,
		value_of_structures: null,
		structure_descriptions: null
	},
	getters: {
		getField
	},
	mutations: {
		updateField
	}
}

export const project_budget = {
	namespaced: true,
	state: {
		accounts: [
			{
				label: 'Land',
				greenbelt_funds: 0,
				match: 0
			},
			{
				label: 'Allowable Minor Improvements',
				greenbelt_funds: 0,
				match: 0
			},
			{
				label: 'Other Improvements',
				greenbelt_funds: 0,
				match: 0
			},
			{
				label: 'ESA',
				greenbelt_funds: 0,
				match: 0
			},
			{
				label: 'Appraisal',
				greenbelt_funds: 0,
				match: 0
			},
			{
				label: 'Survey / Plat',
				greenbelt_funds: 0,
				match: 0
			},
			{
				label: 'Closing Costs',
				greenbelt_funds: 0,
				match: 0
			},
			{
				label: 'Other',
				greenbelt_funds: 0,
				match: 0
			}
		],
		other_description: null,
		match_details: {
			landowner_donation: null,
			provided_grants: null,
			grants: [
				{
					amount: null,
					name: null,
					date_awarded: null
				},
			],
			applicant_amount: null,
			are_additional_matches: null,
			other: null,
			are_in_kind_matches: null,
			in_kind_description: null,
			are_unfunded_grants: null,
			unfunded_grant_description: null
		}
	},
	getters: {
		getField,
		match_percentage(state, getters){
			let match = unformat(getters.getMatchTotal);
			let greenbeltTotal = unformat(getters.getGreenbeltTotal);
			return greenbeltTotal ? Math.round((match / greenbeltTotal)*100) : 0;
		},
		getFunds: (state) => ({index, type}) => {
			return state.accounts[index][type];
		},
		getGreenbeltTotal(state){
			return formatMoney(state.accounts.reduce( (accum, { greenbelt_funds }) => accum += unformat(greenbelt_funds), 0));
		},
		getMatchTotal(state){
			return formatMoney(state.accounts.reduce( (accum, { match }) => accum += unformat(match), 0));
		},
		getGrandTotal(state){
			return formatMoney(state.accounts.reduce( (accum, { greenbelt_funds, match }) => accum += unformat(greenbelt_funds) + unformat(match), 0))
		}
	},
	mutations: {
		updateField,
		setFunds(state, { index, type, value }){
			state.accounts[index][type] = unformat(value);
		},
		addGrant(state){
			state.match_details.grants.push({
				amount: null,
				name: null,
				date_awarded: null
			})
		},
		removeGrant(state, index){
			state.match_details.grants.splice(index, 1);
		}
	},
	actions: {
		addGrant({ state, commit, dispatch }){
			commit('addGrant', null); // payload is null for serialization edgecase. issue #43
			dispatch('application/patchApplication', { path: ['project_budget', 'match_details', 'grants'] , value: state.match_details.grants}, { root: true });
		},
		removeGrant({ state, commit, dispatch }, index){
			commit('removeGrant', index);
			dispatch('application/patchApplication', { path: ['project_budget', 'match_details', 'grants'] , value: state.match_details.grants}, { root: true });
		}
	}
}
